import { AiOutlineClose } from '@react-icons/all-files/ai/AiOutlineClose';
import { AiOutlineMenu } from '@react-icons/all-files/ai/AiOutlineMenu';
import React, { type FC } from 'react';
import { Button } from 'react-daisyui';
import type { MenuButtonsProps } from './types';

const MenuButton: FC<MenuButtonsProps> = ({ setOpen, isOpen }) => (
    <Button
        aria-label="Email"
        onClick={() => {
            setOpen(!isOpen);
        }}
        className={`bg-transparent border-0 m-0 outline-none 
                            cursor-pointer hover:bg-transparent`}
    >
        {isOpen ? <AiOutlineClose size={24} fill="#151515" /> : <AiOutlineMenu size={24} fill="#151515" />}
    </Button>
);

export default MenuButton;
